export function getWeekDates(inputDate) {
  // 支持传入Date对象或日期字符串
  const baseDate = inputDate instanceof Date ? inputDate : new Date(inputDate);
  const weekDays = [
    '星期日',
    '星期一',
    '星期二',
    '星期三',
    '星期四',
    '星期五',
    '星期六',
  ];

  // 计算周一（如果当天是周日，则上周一）
  const dayOfWeek = baseDate.getDay(); // 0是周日，1是周一...
  const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
  const monday = new Date(baseDate);
  monday.setDate(monday.getDate() + mondayOffset);

  const weekDates = [];

  // 生成一周7天的数据
  for (let i = 0; i < 7; i++) {
    const currentDate = new Date(monday);
    currentDate.setDate(monday.getDate() + i);

    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');

    weekDates.push({
      date: `${year}-${month}-${day}`, // 格式如：2023-05-15
      dateCN: `${year}年${month}月${day}日`, // 中文格式
      weekday: weekDays[currentDate.getDay()], // 完整星期
      shortWeekday: weekDays[currentDate.getDay()].replace('星期', '周'), // 简写星期
      isWeekend: [0, 6].includes(currentDate.getDay()), // 是否周末
      isToday: isSameDay(currentDate, new Date()), // 是否是今天
    });
  }

  return weekDates;
}

// 辅助函数：判断两个日期是否是同一天
function isSameDay(date1, date2) {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}
export function getDatetime() {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth() + 1;
  var day = now.getDate();
  var hh = now.getHours();
  var mm = now.getMinutes();
  var ss = now.getSeconds();
  var clock = year + '-';
  if (month < 10) clock += '0';
  clock += month + '-';
  if (day < 10) clock += '0';
  clock += day;
  // clock += day + ' ';
  // if (hh < 10) clock += '0';
  // clock += hh + ':';
  // if (mm < 10) clock += '0';
  // clock += mm + ':';
  // if (ss < 10) clock += '0';
  // clock += ss;
  return clock;
}
export function getDateRange(year) {
  const startDate = new Date(year, 9, 16); // 注意：月份0-11，10月是9
  const endDate = new Date(year, 9, 26);
  const dateList = [];

  // 循环生成每一天
  for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    dateList.push({
      date: `${year}-${month}-${day}`, // 格式化为YYYY-MM-DD
    });
  }

  return dateList;
}
